import { theme } from '@notino/react-styleguide'
import styled, { css } from 'styled-components'
import { SALONS_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'

export const PaymentMethodsDescriptionList = styled.dl`
	list-style: none;
	padding: 0;
	margin: 0;
`

export const PaymentMethodDescriptionItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 0.75rem;
`

export const PaymentMethodDescriptionTerm = styled.dt<{ $isAvailable: boolean }>`
	${theme.typography.labelRegular400};

	${({ $isAvailable }) =>
		$isAvailable
			? css`
					color: ${theme.color.text.primary};
				`
			: css`
					color: ${theme.color.text.tertiary};
				`}

	@media (min-width: ${SALONS_PAGE_MOBILE_BREAKPOINT}) {
		${theme.typography.labelLarge400}
	}
`

export const PaymentMethodDescriptionDescription = styled.dd``

export const PaymentsInfoContainer = styled.div`
	${theme.typography.bodySmall};
	color: ${theme.color.text.tertiary};
	margin-top: 0.25rem;
`
